import React from 'react';
import { Select, Form } from 'antd';
import transportFieldsConnect from '../../../common/hoc/transportFieldsConnect';
const Option = Select.Option;
const SeatMaterialsTypes = ({ form, seatMaterialsTypes }) => {
  const { getFieldDecorator } = form;
  return (
    <Form.Item label="Материал салона">
      {getFieldDecorator('seat_material_key')(
        <Select
          style={{ width: '100%' }}
          allowClear={true}
          className="ui-select"
          mode="multiple"
          placeholder="Выберите материал"
          dropdownClassName="ui-select__dropdown-multiple"
          showArrow={true}
          maxTagCount={0}
          getPopupContainer={trigger => trigger.parentNode}
        >
          {seatMaterialsTypes &&
            seatMaterialsTypes.map(type => (
              <Option
                key={type.seatMaterialKey}
                value={type.seatMaterialKey}
                label={type.seatMaterialName}
              >
                {type.seatMaterialName}
              </Option>
            ))}
        </Select>
      )}
    </Form.Item>
  );
};

export default transportFieldsConnect(SeatMaterialsTypes, [
  'seatMaterialsTypes',
]);
